import { Check } from "lucide-react";
import { Section, Container, Eyebrow, Reveal } from "../components/site/primitives";
import { StatBand, CTABanner } from "../components/site/blocks";
import Seo from "../components/site/Seo";

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Community Tax",
  url: typeof window !== "undefined" ? window.location.origin : "",
  description:
    "Founded by attorneys. 130,000+ clients served and $2.3B+ in tax debt resolved over 15+ years.",
  contactPoint: {
    "@type": "ContactPoint",
    email: "partners@communitytax.com",
    contactType: "Partnerships",
  },
};

const points = [
  "Nationwide team of licensed professionals — attorneys, CPAs, and Enrolled Agents",
  "Partner-driven engagements across financial, tax, and advisory ecosystems",
  "Deep IRS expertise across complex case types for individuals and businesses.",
];

export default function Company() {
  return (
    <>
      <Seo
        title="About Community Tax | Enterprise Tax Debt Representation"
        description="Founded by attorneys. 130,000+ clients served and $2.3B+ in tax debt resolved over 15+ years."
        path="/company"
        jsonLd={orgJsonLd}
      />
      <section className="pt-16 pb-12 lg:pt-24">
        <Container>
          <Eyebrow>Company</Eyebrow>
          <Reveal>
            <h1 className="font-display font-extrabold text-[#1E1E24] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl">
              We Handle the IRS — So You Keep Your Customers
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-[#40424D] leading-relaxed max-w-3xl">
              Founded by attorneys, Community Tax brings enterprise discipline to tax debt
              representation — combining credentialed expertise, transparent pricing, and operational
              scale.
            </p>
          </Reveal>
        </Container>
      </section>

      <section className="pb-4">
        <Container>
          <div className="ct-grad-navy rounded-[28px] p-8 lg:p-14">
            <StatBand
              label="At a Glance"
              dark
              stats={[
                { value: "130,000+", caption: "Clients served" },
                { value: "$2.3B+", caption: "Tax debt resolved" },
                { value: "15+ yrs", caption: "Representation expertise" },
              ]}
            />
          </div>
        </Container>
      </section>

      <Section>
        <div className="max-w-3xl space-y-6">
          {points.map((p, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="flex items-start gap-4 bg-white rounded-2xl ct-shadow-card p-6">
                <span className="mt-0.5 w-8 h-8 rounded-full bg-[#0262B4]/12 flex items-center justify-center shrink-0">
                  <Check className="w-4 h-4 text-[#0262B4]" strokeWidth={3} />
                </span>
                <p className="text-[#1E1E24] leading-relaxed">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-12 text-[#1E1E24] font-medium text-lg leading-relaxed max-w-3xl">
            Community Tax operates with compliance, clear expectations, and a partner-first approach —
            ensuring consistent outcomes at scale.
          </p>
        </Reveal>
      </Section>

      <CTABanner />
    </>
  );
}
